import { getErrorObjectsList } from '@shared/utils/helpers';
import { ErrorMessageStrategy, ResponseError } from '@shared/utils/interfaces';

export const paymentMethodBoNameDuplicateStrategy: ErrorMessageStrategy = (error: ResponseError) => ({
  translationKey: 'errors.PAYMENT_METHOD_BO_NAME_DUPLICATE',
  translationParams: {
    boNames: getErrorObjectsList(error),
  },
});
